import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { AvailableModules } from 'generated/featureDefinitions'
import {
  ContractOverviewPayrollPolicyFragment,
  ContractVersionPageContractVersionFragment,
} from 'generated/resources/graphql'

import ContractData from 'modules/contracts/components/ContractDetails/Section/ContractData'
import { useCanUpsellPayroll } from 'modules/contracts/hooks/useCanUpsellPayroll'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

import BaseSalaryType from './BaseSalaryType'
import GrossSalary from './GrossSalary'
import PayrollPolicy from './PayrollPolicy'

interface Props {
  legalEntityId?: number
  contractVersion: ContractVersionPageContractVersionFragment
  contractPayrollPolicy: ContractOverviewPayrollPolicyFragment | undefined | null
  hasPayrollBundleFeature?: boolean
  isNewAdditionalCompensationsSupportEnabled?: boolean
  cycleInfo?: React.ReactNode
}

const Salary = ({
  legalEntityId,
  contractVersion,
  contractPayrollPolicy,
  hasPayrollBundleFeature,
  isNewAdditionalCompensationsSupportEnabled,
  cycleInfo,
}: Props) => {
  const { canUpsellPayroll } = useCanUpsellPayroll()
  const canSeeGrossSalary = contractVersion._policies?.seeGrossSalary?.can ?? false
  const canSeePayrollPolicy = contractVersion._policies?.seePayrollPolicy?.can ?? false
  const canEdit = contractVersion._policies?.edit?.can ?? false

  const hasPayrollPolicyContent = !!contractPayrollPolicy || canEdit
  const showPayrollPolicy =
    canSeePayrollPolicy && hasPayrollBundleFeature && hasPayrollPolicyContent
  const showGrossSalary = canSeeGrossSalary && (!!contractVersion.salaryAmount || canEdit)
  const isGerman = contractVersion.country === 'de'

  return (
    <>
      <ContractData>
        <Box gap="s24">
          {cycleInfo}
          {isGerman && (
            <BaseSalaryType deBaseSalaryTypeId={contractVersion.deBaseSalaryTypeId ?? null} />
          )}
          {showGrossSalary &&
            contractVersion.salaryFrequency &&
            contractVersion.salaryAmount &&
            legalEntityId && (
              <GrossSalary
                salaryFrequency={contractVersion.salaryFrequency}
                salaryAmount={contractVersion.salaryAmount}
                employeeLegalEntityId={legalEntityId}
              />
            )}
          {!isNewAdditionalCompensationsSupportEnabled && showPayrollPolicy && (
            <PayrollPolicy canEdit={canEdit} contractPayrollPolicy={contractPayrollPolicy} />
          )}
        </Box>
      </ContractData>
      <Box gap="s0">
        {canUpsellPayroll && (
          <UpsellingKit.ProductCard
            moduleRequested={AvailableModules.compensations}
            requestSource="contract overview"
            requestReason={ValidReasons.MissingAddon}
          />
        )}
      </Box>
    </>
  )
}

export default Salary
